export default __webpack_public_path__ + "static/media/mix-cool-people.7a1b2653.mp4";